const isRocket = process.env.CPA_ENV === 'rocket';

const statusesEverad = {
	notConfirmed: 'not_confirmed',
	active: 'active',
	banned: 'banned'
};

const statusesRocket = {
	notConfirmed: 'not_confirmed',
	active: 'active'
};

const localeEverad = {
	ru: {
		notConfirmed: 'не подтвержден',
		active: 'активен',
		banned: 'забанен'
	},
	en: Object.assign({}, statusesEverad, {notConfirmed: 'not conf'}),
	uk: Object.assign({}, statusesEverad, {notConfirmed: 'not conf'}),
	de: {
		notConfirmed: 'unbestätigt',
		active: 'aktiv',
		banned: 'verboten'
	},
	vi: Object.assign({}, statusesEverad, {notConfirmed: 'not conf'}),
	th: {
		notConfirmed: 'ไม่ได้รับการยืนยัน',
		active: 'ใช้งานได้',
		banned: 'ที่ถูกห้าม'
	}
};

const localeRocket = {
	ru: {
		notConfirmed: 'Не подтвержден',
		active: 'Подтвержден'
	},
	en: {
		notConfirmed: 'Not confirmed',
		active: 'Confirmed'
	},
	de: {
		notConfirmed: 'Not confirmed',
		active: 'Confirmed'
	},
	vi: {
		notConfirmed: 'Not confirmed',
		active: 'Confirmed'
	},
	th: {
		notConfirmed: 'Not confirmed',
		active: 'Confirmed'
	}
};

module.exports = {
	enum: isRocket ? statusesRocket : statusesEverad,
	locale: isRocket ? localeRocket : localeEverad
};



// WEBPACK FOOTER //
// ./enums/affiliate-statuses.js